export const ADMIN_SERVICE = 'admin-service'
export const SETTING_SERVICE = 'setting-service'

export const SR_VARIFY_TOKEN = '/auth/verify-token'
export const SR_LOGOUT = '/auth/logout'
